import {Trans} from '@lingui/macro';
import React from 'react';
import styled from 'styled-components';

import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {Accordion} from '../../../../../components/common/accordion/accordion';
import {AccordionSectionData} from '../../../../../components/common/accordion/accordionSection';
import {renderRuleEditorAccordionTitle, StyledRuleEditorAccordionWrap} from '../../ruleEditorSidebar';
import {
  StyledRuleEditorSidebarContainerDiv,
  StyledRuleEditorSidebarSection,
  StyledRuleEditorSidebarSectionTitle,
} from '../../ruleEditorSidebarSection';

/*
 * Constants.
 */

const accordionDefaults = {
  sectionPadding: 5,
};

/*
 * Props.
 */

interface RuleEditorRecipeFaqProps {
  sections: ReadonlyArray<AccordionSectionData>;
}

/*
 * Styles.
 */

const StyledAccordionContentDiv = styled.div`
  p {
    margin: 0 0 3px 0;
  }
  b {
    font-weight: ${fontWeights.semibold};
  }
`;

/*
 * Component.
 */

export const RuleEditorRecipeFaq: React.FC<RuleEditorRecipeFaqProps> = (props) => {
  const {sections} = props;

  return (
    <StyledRuleEditorSidebarContainerDiv>
      <StyledRuleEditorSidebarSection>
        <StyledRuleEditorSidebarSectionTitle>
          <Icon name="help" />
          <Trans id="rule-editor-sidebar-faq-title">FAQ</Trans>
        </StyledRuleEditorSidebarSectionTitle>
        <StyledRuleEditorAccordionWrap>
          <Accordion sections={sections} disableBorders renderSectionTitle={renderRuleEditorAccordionTitle} />
        </StyledRuleEditorAccordionWrap>
      </StyledRuleEditorSidebarSection>
    </StyledRuleEditorSidebarContainerDiv>
  );
};

/*
 * Helpers.
 */

export function buildRuleEditorFaqSections(
  sections: ReadonlyArray<Pick<AccordionSectionData, 'title' | 'content'>>,
): ReadonlyArray<AccordionSectionData> {
  return sections.map((section, index) => ({
    ...accordionDefaults,
    id: `${index + 1}`,
    title: section.title,
    content: <StyledAccordionContentDiv>{section.content}</StyledAccordionContentDiv>,
  }));
}
